import { put } from "redux-saga/effects";
import { Creators as ClientesActions } from "../ducks/clientes";
import { Creators as BancosActions } from "../ducks/bancos";
import { Creators as ClientesStoresActions } from "../ducks/PageStores/clientesStores";

export function* openCustomer({ payload }) {
  yield put(ClientesStoresActions.setClienteAction(payload.action));
  yield put(BancosActions.getListBancosSelects());
  yield put(ClientesActions.getClientes(payload.id));
}



// WEBPACK FOOTER //
// ./src/store/sagas/modalCustomer.js